import tw from 'twin.macro'
import styled, { css } from 'styled-components'
import { MdxWrapperProps } from './types'

export const BASE_MDX_WRAPPER_STYLES = css`
  ${tw`flex flex-col gap-5 text-lg`}

  li {
    ${tw`py-1`}

    p:not(:first-child) {
      ${tw`pt-2`}
    }
  }

  h1 {
    ${tw`text-3xl md:text-5xl`}
  }

  h2 {
    ${tw`text-2xl md:text-4xl`}
  }

  h3 {
    ${tw`text-xl md:text-3xl`}
  }

  h4 {
    ${tw`text-lg md:text-2xl`}
  }

  h5 {
    ${tw`text-base md:text-xl`}
  }

  h6 {
    ${tw`text-base md:text-lg`}
  }

  a {
    ${tw`no-underline text-emerald-500`}
  }

  ul,
  ol {
    ${tw`list-outside pl-6`}
  }

  ol {
    ${tw`list-decimal`}
  }

  ul {
    ${tw`list-disc`}
  }
`

export const Wrapper = styled.div<MdxWrapperProps>`
  ${BASE_MDX_WRAPPER_STYLES}
  ${({ styles }) => styles ?? ''}
`
